/* eslint-disable no-console */
import { WrapFilter } from './styles';

import { isBlank } from 'services/utils/checkers';

import MultiSelect from '../MultiSelect';

import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 */
import { useState, useEffect, useRef } from 'react';

/**
 * FormColumn
 * 
 * @param {object} initialValues
 * @param {boolean} onFormColumnSubmit
 * @param {boolean} onClose
 * @returns 
 */
const FormColumn = ({ initialValues, onFormColumnSubmit, onClose }) => {
  const flex = useRef();

  const [columnLabel, setColumnLabel] = useState('');
  const [columnType, setColumnType] = useState(null);
  const [oldColumnLabel, setOldColumnLabel] = useState(null);
  const [oldColumnType, setOldColumnType] = useState(null);
  const optionsColumnsType = [
    { label: 'Inteiro', value: 'integer' },
    { label: 'Decimal', value: 'decimal' },
    { label: 'Texto', value: 'string' },
    { label: 'Data', value: 'date' },
  ];

  /**
   * Manuseia o submit do formulário
   */
  const handleFormColumn = () => {
    onFormColumnSubmit &&
      onFormColumnSubmit(columnLabel.trim(), columnType, oldColumnLabel);
    setOldColumnLabel(null);
    onClose && onClose();
  };

  useEffect(() => {
    if (initialValues) {
      initialValues.editColumn && setColumnLabel(initialValues.editColumn);
      initialValues.editColumn && setOldColumnLabel(initialValues.editColumn);
      initialValues.editColumnType &&
        setOldColumnType(initialValues.editColumnType);
      initialValues.editColumnType &&
        setColumnType(initialValues.editColumnType);
    }
  }, [initialValues, oldColumnType]);

  return (
    <WrapFilter>
      <div className="form-column-container" ref={flex}>
        <div className="form-column-field">
          <div className="field">
            <Input
              placeholder="Nome da coluna"
              name="column-label"
              type="text"
              inputProps={{ maxLength: 10 }}
              value={columnLabel}
              fullWidth
              onChange={(e) => {
                e.stopPropagation();
                setColumnLabel(e.target.value);
              }}
              className="text-field"
              autoFocus
            />
          </div>
        </div>
        <div className="form-column-field">
          <div className={`field ${oldColumnLabel ? 'disabled' : ''}`}>
            <MultiSelect
              type="radio"
              placeholder="Tipo de atributo"
              name="attribute"
              value={columnType}
              onChange={(v) => {
                setColumnType(v);
              }}
              data={optionsColumnsType}
            />            
            {columnType === 'string' && (
              <label className="label">254 caracteres</label>
            )}
          </div>
        </div>
        <Button
          disabled={isBlank(columnLabel) || (!oldColumnLabel && !columnType)}
          onClick={handleFormColumn}
        >
          {oldColumnLabel ? 'Editar' : 'Adicionar'}
        </Button>
      </div>
    </WrapFilter>
  );
};

FormColumn.properties = {
  ignore: true,
};

export default FormColumn;
